module.exports = __webpack_public_path__ + "static/media/kelly-client.c13ee8bd.jpg";